<template>
  <div class="order-box">
    <div class="follow-bar">
      代理
      <span class="follow-name">{{ item.followName || '--' }}</span>
      <span class="follow-id">UID {{ Number(item.followId) || '--' }}</span>
    </div>
    <div class="order-user">
      <span class="user-name">
        {{ item.fUserName || '--' }}
        <span
          class="user-phone"
          @click="$emit('phone', item)"
          v-if="showPhone"
          >{{ item.memberPhone || item.phone || '--' }}</span
        ></span
      >
      <span class="user-id">UID {{ item.fUserId || '--' }}</span>
    </div>
    <div class="order-header">
      <div class="left">
        <div class="id">
          订单ID {{ item.id }}
          <span class="extra-tag" v-if="item.orderSegmentType == 1230"
            >补款订单</span
          >
        </div>
        <div class="create-time">下单时间：{{ item.createTime }}</div>
      </div>
      <div class="right">
        <div class="amount">
          <span class="rmb">¥</span>{{ NP.divide(Number(item.payAmount), 100) }}
        </div>
        <div class="label">订单金额</div>
      </div>
    </div>
    <div
      class="order-body-wrapper"
      v-if="item.detailLs && item.detailLs.length"
    >
      <div class="order-body--list" :class="isExpand ? 'isExpand' : ''">
        <div
          v-for="(cItem, cIndex) in item.detailLs"
          :key="'child' + cIndex"
          class="order-body"
        >
          <div class="goods-image">
            <img :src="cItem.productImage" alt="" />
          </div>
          <div class="goods-content">
            <div class="disflex justifysb title-line">
              <h2 class="title ellipsis2">
                {{ cItem.productName }}
              </h2>
              <span class="goods-num">x{{ cItem.number }}</span>
            </div>
            <div class="bottom-bar mt5 sku" v-show="cItem.skuValue">
              {{ cItem.skuValue }}
            </div>
            <div class="bottom-bar">
              <span class="price">
                <!-- ¥{{
                  NP.divide(
                    Number(cItem.productOrgPrice * cItem.number * 1),
                    100
                  )
                }} -->
                ¥{{ NP.divide(cItem.productOrgPrice, 100) }}
                <template v-if="cItemIsWeight(cItem)">
                  /
                  {{
                    cItem.expandAttrObj?.productAttr?.weightSaleUnitType == 0
                      ? cItem.expandAttrObj?.productAttr?.weightUnitText
                      : '件'
                  }}
                </template>
              </span>
              <span
                @click="$emit('verify', '', withWeight(cItem), index, cIndex)"
                v-if="showSingleVerify(cItem, item)"
                class="button"
              >
                核销
              </span>
            </div>
          </div>
        </div>
      </div>
      <!-- 控制展开按钮 -->
      <div class="more-bar disflex justifycc" v-if="item.detailLs.length >= 3">
        <span @click="isExpand = !isExpand" style="color: #006cff">
          {{ isExpand ? '收起' : '展开' }}
          <van-icon v-if="isExpand" name="arrow-up" />
          <van-icon v-else name="arrow-down" />
        </span>
      </div>
    </div>
    <div v-if="item.detailLs && item.detailLs.length > 3" class="more-bar">
      <span class="more-goods"
        >等&nbsp;{{ item.detailLs.length }}&nbsp;件商品</span
      >
    </div>
    <div class="order-footer">
      <span :class="['status', `status-${item.status}`]">{{
        item.statusText
      }}</span>
      <div class="right">
        <span @click="$emit('view', item)" class="button" v-if="showDetailBtn">
          查看详情
        </span>
        <span
          @click="$emit('verify', 'all', item, index)"
          v-if="
            storeBusinessStatus &&
            item.detailLs.length >= 2 &&
            (item.isSupportVerifyAll || isLandBill) &&
            showVerify &&
            !isStore &&
            isOpenVerifyButton
          "
          class="button active"
        >
          全部核销
        </span>
      </div>
    </div>
  </div>
</template>

<script>
// 大健康 - 门店系统相关控制器与组件
import StoreController from '@/controllers/storeController/view/store/store.controller.js'
import NP from 'number-precision'
import { mapGetters } from 'vuex'
import { AGRNT_AUTH_CODE } from '@/pages/agent/js/enum'
export default {
  props: {
    item: Object,
    index: [String, Number],
    showUser: Boolean,
    showFollow: Boolean,
    showPhone: {
      type: Boolean,
      default: () => {
        return false
      },
    },
    showVerify: {
      type: Boolean,
      default: () => {
        return true
      },
    },
    /** 条件显示查看详情 */
    showDetailBtn: {
      type: Boolean,
      default: true,
    },
    // 来源：上级页面
    from: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      NP,
      // 展开
      isExpand: false,
    }
  },
  computed: {
    ...mapGetters(['getAgentAuthList']),
    // 提货单页面
    isLandBill() {
      return this.from == 'landBill'
    },
    // * 当前是否门店系统客户模块
    isStore() {
      return StoreController.isStore(this)
    },
    storeBusinessStatus() {
      return StoreController.StoreBusinessStatus()
    },
    // 后台是否开启核销按钮权限
    isOpenVerifyButton() {
      return this.getAgentAuthList.some(
        item => item.permCode === AGRNT_AUTH_CODE.VERIFICATION_BUTTON
      )
    },
  },
  methods: {
    withWeight(item) {
      return {
        ...item,
        isWeight: this.isLandBill ? item.isWeight : this.item.isWeight,
        verifyUrl: this.item.verifyUrl,
        weightIsCredited: this.item.weightIsCredited,
      }
    },
    cItemIsWeight(item) {
      console.log('isWeight.item ==> ', item)
      return (
        item &&
        item.expandAttrObj &&
        item.expandAttrObj.productAttr &&
        item.expandAttrObj.productAttr.isWeight
      )
    },
    showSingleVerify(row, item) {
      // 原有判断
      let oldFlag =
        (row.remainVerifyNumber > 0 || this.isLandBill) &&
        this.showVerify &&
        !this.isStore &&
        this.isOpenVerifyButton
      let weightFalg =
        this.isLandBill && row.isWeight && item.detailLs.length > 1 // 发货单-计重订单一单多品时不允许单个核销
      let flag = oldFlag && !weightFalg
      return flag
    },
  },
}
</script>

<style lang="scss" scoped>
.order-box {
  width: 100%;
  padding: 12px 16px;
  box-sizing: border-box;
  background: #fff;
  border-radius: 12px;
  margin-top: 10px;
  .follow-bar {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 6px 12px;
    box-sizing: border-box;
    background: #f5f7fa;
    border-radius: 8px 8px 8px 8px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 13px;
    color: #000000;
    line-height: 20px;
    margin-bottom: 12px;
    .follow-name {
      margin: 0 8px 0 12px;
    }
    .follow-id {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 13px;
      color: #919499;
      line-height: 20px;
    }
  }
  .order-user {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 16px;
    margin-bottom: 16px;
    border-bottom: 1px solid #edeff2;
    .user-name {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 13px;
      color: #202124;
      line-height: 13px;
    }
    .user-phone {
      margin-left: 10px;
      color: #006cff;
    }
    .user-id {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #919499;
      line-height: 12px;
    }
  }
  .order-body-wrapper {
    .order-body--list {
      max-height: 216px;
      overflow: hidden;
    }
    .order-body--list.isExpand {
      height: auto;
      max-height: unset !important;
      overflow: visible;
    }
  }
  .more-bar {
    width: 100%;
    margin-bottom: 16px;
    .more-goods {
      display: flex;
      padding: 8px 14px;
      box-sizing: border-box;
      background: #f5f7fa;
      border-radius: 6px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #202124;
      line-height: 14px;
      width: fit-content;
    }
  }
  .order-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 12px;
    box-sizing: border-box;
    border-top: 1px solid #edeff2;
    .status {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 12px;
      color: #919499;
      line-height: 12px;
      &.status--4 {
        color: #ffa800;
      }
      &.status-5 {
        color: #ff4444;
      }
      &.status-1 {
        color: #00b849;
      }
      &.status-10 {
        color: #006cff;
      }
      &.status-16 {
        color: #919499;
      }
    }
    .right {
      display: flex;
      align-items: center;
      gap: 10px;
      .button {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #202124;
        line-height: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 80px;
        height: 30px;
        border-radius: 6px;
        border: 1px solid #edeff2;
        &.active {
          color: #006cff;
          border-color: #006cff;
        }
      }
    }
  }
  .order-header {
    padding-bottom: 14px;
    border-bottom: 1px solid #edeff2;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left {
      .id {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 13px;
        color: #202124;
        line-height: 13px;
        margin-bottom: 8px;
        .extra-tag {
          border-radius: 6px;
          margin-left: 10px;
          color: #ff4444;
          background-color: #fff1f1;
          display: inline-block;
          padding: 0 6px;
          font-size: 12px;
          font-weight: 400;
          line-height: 20px; /* 166.667% */
        }
      }
      .create-time {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #919499;
        line-height: 12px;
      }
    }
    .right {
      .amount {
        font-size: 18px;
        font-family: D-DIN-Bold, D-DIN;
        color: #ff4444;
        text-align: right;
        .rmb {
          font-size: 14px;
          margin-right: 4px;
        }
      }
      .label {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #919499;
        line-height: 12px;
        margin-top: 8px;
      }
    }
  }
  .order-body {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 16px 0;
    .goods-image {
      flex-shrink: 0;
      width: 85px;
      height: 85px;
      border-radius: 10px;
      margin-right: 12px;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .goods-content {
      flex: 1;
      height: 85px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-start;
      .title-line {
        width: 100%;
      }
      .title {
        width: 92%;
        flex: 1;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        line-height: 15px;
        height: 34px;
        color: #202124;
      }
      .goods-num {
        flex-shrink: 0;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #919499;
        line-height: 18px;
      }
      .sku {
        color: #60646b;
      }
      .bottom-bar {
        width: 100%;
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        .price {
          font-family: D-DIN, D-DIN;
          font-weight: bold;
          font-size: 16px;
          color: #60646b;
          line-height: 16px;
        }
        .button {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 55px;
          height: 30px;
          border-radius: 6px;
          border: 1px solid #edeff2;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 12px;
          color: #202124;
          line-height: 12px;
        }
      }
    }
  }
}
</style>
